import { render, staticRenderFns } from "./MEM910M04.vue?vue&type=template&id=2d839ff2&"
import script from "./MEM910M04.vue?vue&type=script&lang=js&"
export * from "./MEM910M04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports